
























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import rules from "../../utils/rules";
@Component
export default class EmailDialog extends Vue {
  @Prop() emailDialog!: boolean;
  valid = false;
  emailRules = [rules.email];
  snackbarError = false;
  loadingDelete = false;
  form = {
    email: "",
  };
  close(): void {
    this.$emit("close");
  }

  async sendContact() {
    this.loadingDelete = true;
    try {
      const response = await this.$store.dispatch("contact/createContact", {
        email: this.form.email,
        type: "billboard",
      });
      if (response) {
        this.$emit("onSuccess");
      } else {
        this.$emit("onError");
        this.snackbarError = true;
      }
    } catch (error) {
      this.$emit("onError");
      this.snackbarError = true;
    }

    this.loadingDelete = false;
    this.$emit("close");
  }
}
